import { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom"
import { useSidebar } from "../../SidebarContext";
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify";
import AnalyticsModal from "./AnalyticsModal";
import Swal from "sweetalert2";

function SingleAnalytics() {
    const { isSidebarOpen } = useSidebar();
    const [filter, setFilter] = useState("all");
    const [customRange, setCustomRange] = useState({ start: "", end: "" });
    const [data1, setData1] = useState([]);
    const url = process.env.REACT_APP_LINK;
    const { id, videoId } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [user, setUser] = useState([])
    const [video, setVideo] = useState([])
    const [image, setImage] = useState("");
    const [preImage, setPreImage] = useState("");
    const [data, setData] = useState({
        user_id: "",
        user_name: "",
        video_id: "",
        video: "",
        view_type: "",
        views_count: "",
        subscribers_count: "",
        estimate_earning: "",
        watch_time:""
    })

    console.log(id)
    const filters = [
        {label:"All",value:"all"},
        { label: "Last 7 Days", value: "7days" },
        { label: "Last 14 Days", value: "14days" },
        { label: "Last 28 Days", value: "28days" },
        { label: "Last 60 Days", value: "60days" },
        { label: "Last 90 Days", value: "90days" },
        { label: "Custom", value: "custom" },
    ];

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/analytics/single/${id}/${videoId}`);
            const data = await response.json();
            setData1(data.data.reverse());
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const AnalyticsOptions = [
        { value: 'Boost View', label: 'Boost View' },
        { value: 'Regular View', label: 'Regular View' },
    ];


    useEffect(() => {
        fetchUsers();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreImage(URL.createObjectURL(file));
            setImage(file);
        }
    };

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = data.id !== undefined;
        const urlmain = isEdit
            ? `${url}/api/analytics/${data.id}`
            : `${url}/api/analytics`;
        const method = isEdit ? "PUT" : "POST";

        try {
            // prepare FormData
            // const formData = new FormData();
            // formData.append("user_id", data.user_id);
            // formData.append("user_name", data.user_name || "");
            // formData.append("video_id", data.video_id || "");
            // formData.append("video", data.video);
            // formData.append("views_count", data.views_count);
            // formData.append("subscribers_count", data.subscribers_count);
            // formData.append("estimate_earning", data.estimate_earning);


            // assuming you keep image in separate useState


            const res = await fetch(urlmain, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data), // no need for headers (browser sets it automatically with boundary)

            });

            const result = await res.json();

            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    user_id: result.user_id,
                    user_name: result.user_name,
                    video_id: result.video_id,
                    video: result.video,
                    views_count: result.views_count,
                    subscribers_count: result.subscribers_count,
                    estimate_earning: result.estimate_earning,
                    view_type:result.view_type,
                    watch_time:result.watch_time
                };

                toast.success(isEdit ? "Analytics updated" : "Analytics added");

                fetchUsers();
                setIsModalOpen(false);

                setData({
                    user_id: "",
                    user_name: "",
                    video_id: "",
                    video: "",
                    views_count: "",
                    subscribers_count: "",
                    estimate_earning: "",
                    view_type:"",
                    watch_time:""
                });
                setImage(null);
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        }
    };

    // Filter data
      const getFilteredData = () => {
        // ✅ Show all data by default
        if (!filter || filter === "all") return data1;

        return data1.filter((d) => {
            const createdAt = new Date(d.createdAt);

            if (filter === "custom" && customRange.start && customRange.end) {
                const startDate = new Date(customRange.start);
                const endDate = new Date(customRange.end);
                endDate.setHours(23, 59, 59, 999);
                return createdAt >= startDate && createdAt <= endDate;
            }

            const days = parseInt(filter.replace("days", ""));
            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - days);

            return createdAt >= cutoffDate;
        });
    };



    const filteredData = getFilteredData();

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const fetchUsersAll = async () => {
        try {
            const response = await fetch(`${url}/api/user/admin1997`);
            const data = await response.json();
            // setEmployees(data)
            setUser(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchVideo = async () => {
        try {
            const response = await fetch(`${url}/api/videos/admin1997`);
            const data = await response.json();
            setVideo(data.reverse());
            console.log(data)
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${url}/api/analytics/delete/${id}`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });

                    const res = await response.json();

                    if (response.ok) {
                        Swal.fire(
                            "Deleted!",
                            "The record has been deleted.",
                            "success"
                        );
                        fetchUsers(); // refresh table
                    } else {
                        Swal.fire(
                            "Error!",
                            res.message || "Something went wrong",
                            "error"
                        );
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire(
                        "Error!",
                        "Something went wrong",
                        "error"
                    );
                }
            }
        });
    };

    useEffect(() => {
        fetchUsersAll()
        fetchVideo();
    }, [])



    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div className="releases-analytics-container">
                <div className="releases-analytics-header">
                    <h1>📊 Video Analytics</h1>
                </div>

                {/* Filter Bar */}
                <div className="releases-analytics-filterbar">
                    <div className="releases-analytics-filters">
                        {filters.map((f) => (
                            <button
                                key={f.value}
                                onClick={() => setFilter(f.value)}
                                className={`releases-analytics-filter-btn ${filter === f.value ? "active" : ""
                                    }`}
                            >
                                {f.label}
                            </button>
                        ))}
                    </div>

                    {filter === "custom" && (
                        <div className="releases-analytics-datepicker">
                            <input
                                type="date"
                                value={customRange.start}
                                onChange={(e) =>
                                    setCustomRange((prev) => ({ ...prev, start: e.target.value }))
                                }
                            />
                            <span>to</span>
                            <input
                                type="date"
                                value={customRange.end}
                                onChange={(e) =>
                                    setCustomRange((prev) => ({ ...prev, end: e.target.value }))
                                }
                            />
                        </div>
                    )}
                </div>

                {/* Stats Cards */}
                <div className="releases-analytics-cards">
                    <div className="releases-analytics-card">
                        <h2>Total Views</h2>
                        <p>
                            {filteredData.reduce((sum, d) => sum + d.views_count, 0) || 0}
                        </p>
                    </div>
                    <div className="releases-analytics-card">
                        <h2>Subscribers</h2>
                        <p>
                            {filteredData.reduce((sum, d) => sum + d.subscribers_count, 0) || 0}
                        </p>
                    </div>
                    <div className="releases-analytics-card">
                        <h2>Earnings</h2>
                        <p>
                            ₹
                            {filteredData.reduce((sum, d) => sum + d.estimate_earning, 0) || 0}
                        </p>
                    </div>
                </div>

                {/* Video List */}
                <div >
                    {filteredData.length > 0 ? (

                        <div className="customer-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>User Id</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Video Id</th>
                                        <th>Views</th>
                                        <th>Subscribers</th>
                                        <th>Watch Time</th>
                                        <th>Estimate Earning</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((employee, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {employee.user_id}
                                                </td>

                                                <td>{employee.user_name}</td>
                                                <td>{employee.view_type}</td>
                                                <td>

                                                    {/* <div
                                                className="releases-description-cell"
                                                dangerouslySetInnerHTML={{ __html: employee.description }}
                                            /> */}
                                                    {employee.video_id}
                                                </td>


                                                <td>{employee.views_count}</td>
                                                <td>{employee.subscribers_count}</td>
                                                <td>{employee.watch_time}</td>
                                                <td>{employee.estimate_earning}</td>

                                                <td>{new Date(employee.createdAt).toLocaleString()}</td>
                                                <td>
                                                    <button className="edit-button"
                                                        onClick={() => {

                                                            setData({
                                                                id: employee.id, // include ID for PUT request
                                                                user_id: employee.user_id,
                                                                user_name: employee.user_name || "",
                                                                video_id: employee.video_id || "",
                                                                views_count: employee.views_count || "",
                                                                subscribers_count: employee.subscribers_count || "",
                                                                estimate_earning: employee.estimate_earning || "",
                                                                view_type:employee.view_type,
                                                                watch_time:employee.watch_time
                                                                // win_amount: employee.win_amount || ""
                                                            });

                                                            setIsModalOpen(true);
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-pencil edit-oms"></i>
                                                    </button>
                                                    <button className="delete-button" onClick={() => handleDelete(employee.id)}>
                                                        <i className="fa-solid fa-trash delete-oms"></i>
                                                    </button>
                                                    {/* <button action="Analytics" onClick={() => navigate(`/analytics/${employee.user_id}/${employee.video_id}`)}>
                                                        <i class="fa-solid fa-eye"></i>
                                                    </button> */}
                                                </td>
                                                {/* <td>
                                            
                                        </td> */}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="releases-analytics-nodata">No data available</p>
                    )}
                    <div className="pagination">
                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                        </button>



                        <button className="active">
                            {currentPage}
                        </button>

                        {currentPage < totalPages && (
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                        )}

                        {currentPage + 1 < totalPages && (
                            <span className="dots">...</span>
                        )}

                        {currentPage !== totalPages && (
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        )}

                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
            <AnalyticsModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                image={image}
                preImage={preImage}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
                handleThumbnailChange={handleThumbnailChange}
                setData={setData}
                user={user}
                video={video}
                AnalyticsOptions={AnalyticsOptions}
            />
        </div>
    );
}

export default SingleAnalytics;
